import React from 'react';
import { Tooltip, TooltipProps } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => {
  return createStyles({
    tooltip: {
      background: '#FFFFFF',
      color: '#212121',
      marginTop: '-14px',
      padding: '8px',
      boxShadow:
        '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
    },
    title: {
      fontSize: '1rem',
      margin: 5,
    },
  });
});

const CustomTooltip: React.FC<TooltipProps> = ({
  title = '',
  children,
  disableHoverListener,
}: TooltipProps) => {
  const classes = useStyles();

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={<p className={classes.title}>{title}</p>}
      disableHoverListener={disableHoverListener}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
